export default __webpack_public_path__ + "static/media/instagram.620fcdc9.svg";